import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "searchFrom" }
const _hoisted_2 = { style: {"margin-top":"20px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_XAtable = _resolveComponent("XAtable")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_tree = _resolveComponent("a-tree")!
  const _component_x_dialog = _resolveComponent("x-dialog")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_form, {
        name: "customized_form_controls",
        layout: "inline",
        model: $setup.searchFormState
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, { label: "角色名称" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: $setup.searchFormState.roleName,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (($setup.searchFormState.roleName) = $event)),
                placeholder: "输入角色名称"
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                style: {"margin-right":"10px"},
                onClick: $setup.resetForm
              }, {
                default: _withCtx(() => [
                  _createTextVNode("重置")
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: $setup.search,
                style: {"margin-right":"10px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode("搜索")
                ]),
                _: 1
              }, 8, ["onClick"]),
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "primary",
                onClick: $setup.addClick
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 添加 ")
                ]),
                _: 1
              }, 8, ["onClick"])), [
                [_directive_permission, 'sysRole.menu.update']
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_XAtable, {
        columns: $setup.columns,
        dataSource: $setup.tableData,
        loading: $setup.loading,
        scroll: { x: 1200 }
      }, {
        roleType: _withCtx(({ scope }) => [
          _createElementVNode("span", null, _toDisplayString((scope.record as any).roleType === 0
            ? "管理员"
            : (scope.record as any).roleType === 1
            ? "代理"
            : "-"), 1)
        ]),
        status: _withCtx(({ scope }) => [
          _createElementVNode("span", null, _toDisplayString((scope.record as any).status === 1 ? "启用" : "禁用"), 1)
        ]),
        control: _withCtx(({ scope }) => [
          _createVNode(_component_a_button, {
            type: "primary",
            size: "small",
            onClick: ($event: any) => ($setup.configPermission(scope.record as any))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 配置权限 ")
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]),
        _: 1
      }, 8, ["columns", "dataSource", "loading"]),
      _createVNode(_component_a_pagination, {
        current: $setup.pageNo,
        "onUpdate:current": _cache[1] || (_cache[1] = ($event: any) => (($setup.pageNo) = $event)),
        onChange: $setup.pageNoChange,
        total: $setup.total,
        "page-size": $setup.pageSize,
        hideOnSinglePage: "",
        onShowSizeChange: $setup.onShowSizeChange,
        style: {"margin-top":"5px"}
      }, null, 8, ["current", "onChange", "total", "page-size", "onShowSizeChange"])
    ]),
    _createVNode(_component_x_dialog, {
      title: "配置权限",
      visible: $setup.permissionVisible,
      onCancel: $setup.handlePermissionCancel,
      onIsDestroyOnClose: _cache[3] || (_cache[3] = ($event: any) => ($setup.permissionLoading = false)),
      onConfirm: $setup.confirmPermission,
      loading: $setup.permissionLoading
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_tree, {
          checkedKeys: $setup.checkedKeys,
          "onUpdate:checkedKeys": _cache[2] || (_cache[2] = ($event: any) => (($setup.checkedKeys) = $event)),
          checkable: "",
          "tree-data": $setup.menuTreeData,
          "field-names": {
        title: 'permissionName',
        key: 'id',
        children: 'children',
      }
        }, null, 8, ["checkedKeys", "tree-data"])
      ]),
      _: 1
    }, 8, ["visible", "onCancel", "onConfirm", "loading"]),
    _createVNode(_component_x_dialog, {
      title: "添加角色",
      visible: $setup.addVisible,
      onCancel: $setup.handleAddCancel,
      onIsDestroyOnClose: _cache[7] || (_cache[7] = ($event: any) => ($setup.addLoading = false)),
      onConfirm: $setup.confirmAdd,
      loading: $setup.addLoading
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: $setup.addFormState,
          ref: "addFormRef",
          labelCol: { span: 5, offset: 0 }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "角色名称",
              name: "roleName",
              rules: [{ required: true, message: '请输入角色名称' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: $setup.addFormState.roleName,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (($setup.addFormState.roleName) = $event)),
                  placeholder: "请输入角色名称"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "角色类型",
              name: "roleType",
              rules: [{ required: true, message: '请选择角色类型' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: $setup.addFormState.roleType,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => (($setup.addFormState.roleType) = $event)),
                  placeholder: "请选择角色类型"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: 0 }, {
                      default: _withCtx(() => [
                        _createTextVNode("管理员")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: 1 }, {
                      default: _withCtx(() => [
                        _createTextVNode("代理")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "状态",
              name: "status",
              rules: [{ required: true, message: '请选择状态' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: $setup.addFormState.status,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => (($setup.addFormState.status) = $event)),
                  placeholder: "请选择状态"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: 1 }, {
                      default: _withCtx(() => [
                        _createTextVNode("启用")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: 0 }, {
                      default: _withCtx(() => [
                        _createTextVNode("禁用")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible", "onCancel", "onConfirm", "loading"])
  ], 64))
}